/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React from "react";
import { statusConfig } from "../../utils/constants";

const StatusBadge = ({ status }) => {
  const config = statusConfig[status] || statusConfig.default;
  const Icon = config.icon;

  return (
    <span
      className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-xs font-bold border ${config.bg} ${config.text} ${config.border} truncate max-w-[120px]`}
    >
      <Icon size={12} className="flex-shrink-0" />
      <span className="truncate">{status}</span>
    </span>
  );
};

export default StatusBadge;
